var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailed = function SvgFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 0H13.6001L20.6001 4V20H7.6001L0.600098 16V0Z",
    fill: "#E0A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1001 9V11.5H11.1001V9H10.1001Z",
    fill: "#861313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6001 13.375C10.2549 13.375 9.9751 13.0952 9.9751 12.75C9.9751 12.4048 10.2549 12.125 10.6001 12.125C10.9453 12.125 11.2251 12.4048 11.2251 12.75C11.2251 13.0952 10.9453 13.375 10.6001 13.375Z",
    fill: "#861313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0372 5.25718C10.949 5.09845 10.7817 5 10.6001 5C10.4185 5 10.2512 5.09845 10.163 5.25718L5.16302 14.2572C5.07698 14.412 5.07932 14.6009 5.16916 14.7536C5.259 14.9063 5.42294 15 5.6001 15H15.6001C15.7773 15 15.9412 14.9063 16.031 14.7536C16.1209 14.6009 16.1232 14.412 16.0372 14.2572L11.0372 5.25718ZM10.6001 6.52956L14.7503 14H6.44985L10.6001 6.52956Z",
    fill: "#861313"
  })));
};
export { SvgFailed as ReactComponent };
export default __webpack_public_path__ + "assets/1d510090.svg";